import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import router from './router'
import { setInvalidateSessionHandler } from './services/api'
import { useSessionStore } from './stores/session'
import '@fontsource-variable/inter/opsz.css'
import './assets/css/main.css'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(createHead())
app.use(router)

// Wire 401 handler AFTER Pinia is active so sessionStore.invalidate() is callable
const sessionStore = useSessionStore()
setInvalidateSessionHandler(() => sessionStore.invalidate())

app.mount('#app')
